import React, { useEffect, useState } from "react";
import { Select, MenuItem, Chip } from "@mui/material";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Text from "components/common/Text";
import { makeStyles } from "@mui/styles";
import CTable from "components/common/Table";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import Stack from "components/common/Stack";
import VehiclesDrawer from "./VehiclesDrawer";
import SearchBar from "components/common/SearchBar";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import VehicleTemplate from "../../template/vehicles_Template.xlsx"
import { format } from "date-fns";
import IconButton from "components/common/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import IconButton from "components/common/IconButton";

import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import * as FileSaver from 'file-saver'
import { VehicleApiData } from "stores/vehicles/VehicleApi";

const useStyles = makeStyles(() => ({
  center: {
    marginTop: "1.6rem",
  },
  menuitem: {
    alignItems: "center",
    padding: "0 8px",
    backgroundColor: "unset !important",
    color: "#004AAD",
    marginRight: "10px",
    border: "1px solid #004AAD",
  },
  text: {
    fontSize: "22px",
    marginBottom: "40px",
    display: "flex",
    alignItems: "center",
    color: "#707070",
  },
  chipBox: {
    display: "flex",
    alignItems: "center",
  },
  searchBoxContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: "20px",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  filterIcon: {
    marginLeft: "10px",
    cursor: "pointer",
  },
  table: {
    "@media (max-width:768px)": {
      marginTop: "99%",
    },
  },
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
    height:'22px'
  },
}));
const filteroldest = ["All","latest", "oldest"];




const Vehicles = ({
  applyFilter,
  toggleDrawer,
  drawerOpen,
  vehicledata,
  handleAddVehicle,
  onPageChange,
  page,
  limit,
  isloading,
  onChange,
  searchhandleChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  handleReset,
  handleChangeSorting,
  sorting,
  handleDeleteConfirmVehiceClick,
  handleEditVehicle
}) => {

  
  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      valueGetter: (v, d) => (     
        <>
        <span>
        {format(new Date(d.created_at), "dd MMM yyyy")}
          </span>
        </>
      ),
    },
    {
      field: "type",
      headerName: <span>EV Type</span>,
    },
    // {
    //   field: "sub_type",
    //   headerName: <span>Sub Type</span>,
    // },
    {
      field: "name",
      headerName: <span>Brand</span>,
    },
  
    {
      field: "model_name",
      headerName: <span>Model</span>,
    },
    {
      field: "variant",
      headerName: <span>Variant</span>,
    },
    {
      field: "battery_capacity",
      headerName: <span>Battery Capacity</span>,
    },
    {
      field: "ac_names",
      headerName: "AC",
      valueGetter: (v, d) => (
        <>
          {v.map((name, index) => (
            <React.Fragment key={index}>
              <span>{name}</span>
              {index < v.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      ),
    },
    {
      field: "dc_names",
      headerName: "DC",
      valueGetter: (v, d) => (
        <>
          {v.map((name, index) => (
            <React.Fragment key={index}>
              <span>{name}</span>
              {index < v.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      ),
    },
    {
      field: "Action",
      headerName: "Action",
      valueGetter: (v, d) => {
        console.log('defe',d);
        
        const vehicle = {
          id: d?.id,
          name: d?.manufacturerId,
          type: d?.typeId,
          model_name: d?.modelId || "N/A",
          variant: d?.variant || "N/A",
          battery_capacity: d?.battery_capacity || "N/A",
          ac_names: d?.ac_names || "N/A",
          dc_names: d?.dc_names || "N/A",
          year:d?.year||"N/A"
        };
        return (
          <>
            {
              <div sx={{ display: "flex",
                justifyContent: "start",
                minWidth: "100px"}}>
                <span style={{ marginRight: "30px" }}>
                  <IconButton
                    aria-label="edit"
                    sx={{
                      color: "red",
                    }}
                  >
                    <DeleteOutlineOutlinedIcon
                      sx={{ fontSize: "22px" }}
                      onClick={() =>
                        handleDeleteConfirmVehiceClick( vehicle)
                      }
                    />
                  </IconButton>
                </span>
                <span>
                  <IconButton
                    variant="outlined"
                    aria-label="edit"
                    sx={{
                      color: "green",
                    }}
                  >
                    <EditOutlinedIcon
                      sx={{ fontSize: "22px" }}
                      onClick={() =>
                        handleEditVehicle(vehicle)
                      }
                    />
                  </IconButton>
                </span>
              </div>
            }
          </>
        );
      },
    },
  ];

  const [vehicleExcelData , setVehicleExcelData]= useState('')



  const classes = useStyles();
  const vehicles = vehicledata?.vehicles ?? [];
  const dropdowns = vehicledata?.dropdowns ?? [];
  console.log("efgyywe",vehicles);
  
  const formattedVehicles = vehicles.map((vehicle) => ({
    // sub_type: vehicle?.sub_type || "N/A",
    id:vehicle?.id ?? "N/A",
    name: vehicle?.manufacturer?.name ?? "N/A",
    manufacturerId:vehicle?.manufacturer_id??"N/A",
    modelId:vehicle?.model_id??"N/A",
    year:vehicle?.year??'N/A',
    type: vehicle?.manufacturer?.type?.name ?? "N/A",
    typeId: vehicle?.manufacturer?.type?.id ?? "N/A",
    model_name: vehicle?.model?.name || "N/A",
    variant: vehicle?.variant?.name || "N/A",
    battery_capacity: vehicle?.battery_capacity || "N/A",
    ac_names: vehicle?.ac || "N/A",
    dc_names: vehicle?.dc || "N/A",
    created_at:vehicle?.created_at||"N/A"
  }));

  // const handleChange = (event) => {
  //   const value = event.target.value;
  //   setSelectedValue(value);
  //   // handelfilterdata(value);
  // };


  useEffect(() => {
    const fetchVehicleData = async () => {
        try {
            const limit = vehicledata?.totalCount;
                const data = await VehicleApiData.ExportBulk({ limit });
                setVehicleExcelData(data?.result?.data); 
        } catch (error) {
            console.error("Error exporting vehicle data:", error);
        }
    };

    fetchVehicleData();
}, [vehicledata]);
  // const reverseData = formattedVehicles.reverse();
  const downloadAsExcel = () => {
    const vehiclesData = vehicleExcelData?.vehicles?.map((d) => ({
      Date: format(new Date(d.created_at), "dd MMM yyyy"),
      // SubType: d?.sub_type,
      "EV Type": d?.manufacturer?.type?.name,
      Brand: d?.manufacturer?.name,
      Model: d?.model?.name,
      Variant: d?.variant?.name,
      "Battery Capacity": d?.battery_capacity,
      "AC": d?.ac?.join(", "), 
      "DC": d?.dc?.join(", "),
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(vehiclesData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "vehicles Data");
    XLSX.writeFile(workbook, "VehiclesDetails.xlsx");
  };
  

  const downloadVehicleTemplate = () => {
    FileSaver.saveAs(
      VehicleTemplate,
      'Vehicle Template.xlsx'
    )
  }
  return (
    <>
      <Box className={classes.center}>
        <Card>
          <CardContent>
            <Box>
              <Stack
                direction={{ sm: "column", xs: "column", md: "row" }}
                spacing={2}
                justifyContent="space-between"
                marginBottom="10px"
              >
                <Box>
                  <Text variant="h5" className={classes.text}>
                    Vehicles
                  </Text>
                </Box>

                <Box className={classes.chipBox}>
                  <Chip
                    onClick={() => handleAddVehicle("addvehicle")}
                    className={classes.menuitem}
                    label="+ Add Vehicles"
                  />
                  <Chip
                    onClick={() => handleAddVehicle("addBulk")}
                    className={classes.menuitem}
                    label="+ Add bulk"
                  />
                   <Chip
                    onClick={() => downloadVehicleTemplate()}
                    className={classes.menuitem}
                    label="Download Template"
                  />
                  <span
                    onClick={() => downloadAsExcel()}
                    className={classes.exportfile}
                  >
                    <FileDownloadIcon
                      sx={{ fontSize: "20px", mt: "3px" }}
                      className={classes.fileDownload_icon}
                    />
                    Export Report
                  </span>
                </Box>
              </Stack>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex" }}>
              <Box sx={{minWidth:200,maxWidth:200,marginRight:'10px' }}>

              <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "15px", color: "#9e9e9e" }}
                      id="demo-simple-select-label"
                    >
                      Select Filter
                    </InputLabel>

                    <Select
                      sx={{ fontSize: "15px" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Filter"
                      // value={sorting}
                      value={ sorting
                        ? sorting
                        : "All"}
                      onChange={handleChangeSorting}
                    >
                      {filteroldest.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              </Box>
                <Box sx={{minWidth:200,maxWidth:200 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "14px" }}
                      className={classes.datePickerInput}
                      id="daterange-label"
                    >
                      Date Range
                    </InputLabel>
                    <OutlinedInput
                     sx={{ height: "37px",fontSize:'11px', cursor:'pointer'}}
                      label="Date Range"
                      className={classes.table_date}
                      id="outlined-adornment-amount"
                      value={
                        fromat_date_from && fromat_date_to
                          ? `${fromat_date_from} - ${fromat_date_to}`
                          : ""
                      }
                      onClick={handleDatePickerOpen}
                      endAdornment={
                        <InputAdornment position="end" sx={{cursor:'pointer'}}>
                          <EventIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <Box
                  style={{ maxWidth: 173, minWidth: 173, marginRight: "10px" }}
                >
                </Box>
                
                  <div></div>
                </Box>
                </Box>
                <Dialog
                  open={datePickerOpen !== undefined ? datePickerOpen : false}
                  onClose={handleDatePickerClose}
                  title="Select a date range"
                  children={
                    <DatePickerModal
                      onClose={handleDatePickerClose}
                      onDatePickerSub={onDatePickerSub}
                      from_date={from_date}
                      to_date={to_date}
                      handleChange={onChange}
                      handleReset={handleReset}
                    />
                  }
                />
                <Box className={classes.searchBoxContainer}>
                  <SearchBar
                    onSearchChange={(value) =>
                      searchhandleChange("inputsearch", value)
                    }
                  />
                  <FilterListOutlinedIcon
                    className={classes.filterIcon}
                    onClick={() => toggleDrawer(true)}
                  />
                </Box>
              </Box>
            </Box>

            <CTable
              columns={columns}
              data={formattedVehicles ?? []}
              pagination={true}
              count={vehicledata?.totalCount }
              page={page}
              rowsPerPage={limit}
              onPageChange={onPageChange}
              isLoading={isloading}
            />
          </CardContent>
        </Card>
      </Box>
      <VehiclesDrawer
        applyFilter={applyFilter}
        toggleDrawer={toggleDrawer}
        drawerOpen={drawerOpen}
        filters={dropdowns ?? []}
      />
    </>
  );
};

export default Vehicles;
